<template>
  <div class="bigEvent newEvent race" :class="{floating: !inplace}"
       :style="inplace ? {} : {left: ev.position.left + 'px', top: ev.position.top + 'px'}">
  <v-form @submit.prevent="saveRace" novalidate>
    <div class="event-header">
      <span class="event-date">{{ ev.datetime.date() }} <template v-if="$mq == 'sm'">({{ ev.datetime.format('ddd')}})</template></span>
      <span class="event-name">
        ZAWODY
      </span>
      <span class="event-actions">
        <v-icon dark class="click-effect ml-2" v-tooltip="'Zamknij'" @click.stop="$emit('close')">close</v-icon>
      </span>
    </div>
    <div class="event-content">
      <ul>
        <li>
          <v-text-field
              v-model="race.name"
              label="Nazwa"
              :error="hasErrors('name')"
              :error-messages="getErrors('name')"
          >
            <i slot="prepend" v-tooltip="'Nazwa'" class="text-icon">N</i>
          </v-text-field>
        </li>
        <li>
          <v-text-field
              v-model="race.city"
              label="Miasto"
              :error="hasErrors('city')"
              :error-messages="getErrors('city')"
          >
            <v-icon slot="prepend" v-tooltip="'Miasto'">location_city</v-icon>
          </v-text-field>
        </li>
        <li>
              <v-select
                v-model="race.race_type"
                :items="allRaceTypesStringsOptions"
                label="Rodzaj"
                :error="hasErrors('race_type')"
                :error-messages="getErrors('race_type')"
                @change="changeRaceType"
              >
                <i slot="prepend" v-tooltip="'Nazwa'" class="text-icon">R</i>
              </v-select>
        </li>
        <li v-if="['street', 'track'].indexOf(race.race_type) > -1">
          <v-select
              v-model="race.distance_string"
              label="Dystans"
              :items="distanceOptions"
              :error="hasErrors('distance_string')"
              :error-messages="getErrors('distance_string')"
          >
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
          </v-select>
        </li>
        <li v-if="['other', 'ultra'].indexOf(race.distance_string) > -1">
          <v-text-field
              v-model="race.distance_km"
              label="Dystans w kilometrach"
              :error="hasErrors('distance_km')"
              :error-messages="getErrors('distance_km')"
          >
            <i slot="prepend" v-tooltip="'Dystans w kilometrach'" class="fi flaticon-road-1"></i>
          </v-text-field>
        </li>
        <li v-if="race.race_type === 'street'">
          <v-checkbox
            label="Atest"
            v-model="race.certified"
            :error="hasErrors('certified')"
            :error-messages="getErrors('certified')"
            >
            <v-icon slot="prepend" v-tooltip="'Atest'">spellcheck</v-icon>
          </v-checkbox>
        </li>
        <li>
          <v-select
              label="Priorytet"
              v-model="race.priority"
              :items="allRacePrioritiesOptions"
              :error="hasErrors('priority')"
              :error-messages="getErrors('priority')"
              dense
          >
            <i slot="prepend" v-tooltip="'Priorytet'" class="text-icon">P</i>
          </v-select>
        </li>
      </ul>
      <v-textarea
          v-model="race.trainer_remarks"
          label="Informacje dodatkowe"
          :error="hasErrors('trainer_remarks')"
          :error-messages="getErrors('trainer_remarks')"
          auto-grow
          box
      >
        <v-icon slot="prepend" v-tooltip="'Informacje dodatkowe'">info</v-icon>
      </v-textarea>
      <div class="save-button-container">
        <v-btn small dark class="very-small" color="tertiary" type="submit">
          zapisz
          <v-icon right small >save</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="event-footer">
    </div>
  </v-form>
  </div>
</template>

<script>
import {createRace, updateRace} from './api'
import { mapGetters } from 'vuex'
import iziToast from 'izitoast'

export default {
  props: {
    ev: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: {},
      race: {}
    }
  },
  computed: {
    ...mapGetters([
      'allRaceTypesStringsOptions', 'raceDistanceStreetStringsOptions',
      'allRaceDistanceStringsOptions', 'raceDistanceTrackStringsOptions',
      'allRacePrioritiesOptions', 'runner'
    ]),
    isNew () {
      return this.race.id === undefined
    },
    distanceOptions () {
      if (this.race.race_type === 'street') {
        return this.raceDistanceStreetStringsOptions
      }
      if (this.race.race_type === 'track') {
        return this.raceDistanceTrackStringsOptions
      }
      return [
        {
          text: 'inne',
          value: 'other'
        }
      ]
    }
  },
  created () {
    this.initRace()
  },
  methods: {
    initRace () {
      this.race = {...this.ev}
    },
    changeRaceType () {
      if (this.race.race_type !== 'street' && this.race.race_type !== 'track') {
        this.race.distance_string = 'other'
      } else {
        this.race.distance_string = null
      }
    },
    saveRace () {
      if (this.isNew) {
        var promise = createRace(this.runner, this.race).then((data) => {
          this.$emit('created-race', data)
          iziToast.show({
            message: 'Zawody zostały dodane',
            color: 'green'
          })
          return data
        })
      } else {
        promise = updateRace(this.runner, this.race).then((data) => {
          this.$emit('updated-race', data, this.ev)
          iziToast.show({
            message: 'Zawody zostały zmienione',
            color: 'green'
          })
          return data
        })
      }
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/RaceForm.vue